// extracted by mini-css-extract-plugin
export default {"crossIcon":"ClearIndicator_crossIcon__SNiu8"};